import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'create-site' as const;

const argumentZod = z.object({
  name: z
    .string()
    .describe('The display name for the new site (e.g. "My Portfolio")'),
  templateId: z
    .string()
    .optional()
    .describe('Optional template ID to create the site from'),
  parentFolderId: z
    .string()
    .optional()
    .describe(
      'Optional folder ID in the workspace dashboard to place the site in'
    ),
});

export const createSiteManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Create site',
  family: 'site',
  llmTool: {
    name: toolName,
    description:
      'Creates a new site in the current workspace. Returns the created site metadata including its ID, display name, short name, and preview URL.',
    inputSchema: argumentZod,
  },
  type: 'server',
  // No GRACE permission — createSiteForWorkspace handles its own
  // workspace-level permission checks (canWorkspaceCreateMoreSites).
  confirmBeforeExecuting: true,
});

export type CreateSiteArgumentType = z.infer<typeof argumentZod>;
